@if (!showToolTip) {
  <div class="form-group">
    @if (showLabel) {
      <label>{{isEdit ? 'What is your industry?' : 'Industry'}}</label>
    }
    <select
      class="form-control"
      [(ngModel)]="industry"
      [disabled]="readOnly"
      (change)="onIndustryChange()">
      <option value="" disabled hidden>-- Select Industry --</option>
      @for (item of industries; track item) {
        <option [value]="item.industry">{{item.industry}}</option>
      }
    </select>
  </div>
  <div class="form-group">
    @if (showLabel) {
      <label>{{isEdit ? 'What is your occupation?' : 'Occupation'}}</label>
    }
    <select
      class="form-control"
      [(ngModel)]="occupation"
      [disabled]="readOnly || !industry"
      (change)="onOccupationChange()">
      <option value="" disabled hidden>-- Select Occupation --</option>
      @for (item of occupations; track item) {
        <option [value]="item.occupation_name">{{item.occupation_name}}</option>
      }
    </select>
  </div>
}

@if (showToolTip) {
  <div class="mb-30">
    @if (showLabel) {
      <label>{{isEdit ? 'What is your industry' : 'Industry'}}</label>
    }
    <div class="input-group">
      <select
        class="form-control"
        [(ngModel)]="industry"
        [disabled]="readOnly"
        (change)="onIndustryChange()">
        <option value="" disabled hidden>-- Select Industry --</option>
        @for (item of industries; track item) {
          <option [value]="item.industry">{{item.industry}}</option>
        }
      </select>
      <div class="input-group-append">
        <a
          class="input-group-icon popover-trigger popover-trigger--sm"
          tabindex="0"
          data-toggle="popover"
          data-trigger="focus"
          [attr.data-html]="isToolTipContentHtml"
          [attr.data-placement]="toolTipPlacement"
          [attr.data-content]=toolTipContent>
          <svg class="icon">
            <use xlink:href="#info"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div class="mb-30">
    @if (showLabel) {
      <label>{{isEdit ? 'What is your occupation?' : 'Occupation'}}</label>
    }
    <div class="input-group">
      <select
        class="form-control"
        [(ngModel)]="occupation"
        [disabled]="readOnly || !industry"
        (change)="onOccupationChange()">
        <option value="" disabled hidden>-- Select Occupation --</option>
        @for (item of occupations; track item) {
          <option [value]="item.occupation_name">{{item.occupation_name}}</option>
        }
      </select>
      <div class="input-group-append">
        <a
          class="input-group-icon popover-trigger popover-trigger--sm"
          tabindex="0"
          data-toggle="popover"
          data-trigger="focus"
          [attr.data-html]="isToolTipContentHtml"
          [attr.data-placement]="toolTipPlacement"
          [attr.data-content]=toolTipContent>
          <svg class="icon">
            <use xlink:href="#info"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
}

@if (itk) {
  <div class="custom-amount__note">
    <div class="note note--info note--darkcopy">
      <div class="note__icon">
        <svg class="icon">
          <use xlink:href="#info-small"></use>
        </svg>
      </div>
      <div class="note__content">
        <p [innerHTML]="itk"></p>
      </div>
    </div>
  </div>
}
